import { FC } from "react";
import { ReactComponent as CheckmarkIcon } from "../../../public/icons/checkmark.svg";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import { MultipleFieldErrors } from "react-hook-form";

const RequirementsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const PasswordRequirement = styled.div<{ active: boolean }>`
  display: flex;
  color: ${(props) => (props.active ? "#000" : "#eee")};
  > svg {
    color: ${(props) => (props.active ? "#00B167" : "#eee")};
  }
`;

const CheckMark = styled(CheckmarkIcon)`
  margin-right: 8px;
`;

const PasswordRequirements: FC<{
  errors?: MultipleFieldErrors;
  empty: boolean;
}> = ({ errors, empty }) => {
  const { t } = useTranslation();

  return (
    <RequirementsContainer>
      <PasswordRequirement active={!empty && !errors?.length}>
        <CheckMark />
        <span>{t("passwordRequirements.length", { length: 8 })}</span>
      </PasswordRequirement>

      <PasswordRequirement
        active={!empty && !errors?.uppercase && !errors?.specialCharacter}
      >
        <CheckMark />
        <span>{t("passwordRequirements.upperCaseAndSpecialChar")}</span>
      </PasswordRequirement>

      <PasswordRequirement active={!empty && !errors?.lowercase}>
        <CheckMark />
        <span>{t("passwordRequirements.lowerCase")}</span>
      </PasswordRequirement>

      <PasswordRequirement active={!empty && !errors?.number}>
        <CheckMark />
        <span>{t("passwordRequirements.number")}</span>
      </PasswordRequirement>
    </RequirementsContainer>
  );
};

export default PasswordRequirements;
